/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import {
    Col,
    Container,
    Form,
    Modal,
    Row,
    Spinner,
    Image
} from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useBetween } from "use-between";
import Layout from "../../layout";
import "./index.scss";
import useApi from "../../pages/useApi";
import { useNavigate } from "react-router-dom";
import { EmailIcon, PhoneIcon } from "../../components/icons";
import { toDateType } from "../../plugins";
import AwareButton from "../../components/button";
import { toast } from "react-toastify";
import moment from "moment-timezone";
import { Cart } from "../../components";
import OrderSuccessIcon from "../../assets/images/profile/order-success-icon.png";

const Checkout = () => {
    const [totalPrice, setTotalPrice] = useState(0);
    const [originalPrice, setOriginalPrice] = useState(0);
    const [date, setDate] = useState(null);
    const [startDate, setStartDate] = useState(new Date());
    const [deliveryTimeOpen, setDeliveryTimeOpen] = useState(null);
    const [deliveryTimeClosed, setDeliveryTimeClosed] = useState(null);
    const [defaultDelivery, setDefaultDelivery] = useState(false);

    const [note, setNote] = useState("");
    const [cartDetails, setCartDetails] = useState([]);
    const [discountCode, setDiscountCode] = useState("");
    const [appliedCoupon, setAppliedCoupon] = useState(null);
    const [applyingCoupon, setApplyingCoupon] = useState(false);
    const [filterDays, setFilterDays] = useState([0, 1, 2, 3, 4, 5, 6]);
    const [show, setShow] = useState(false);
    const [status, setStatus] = useState(false);
    const options = { style: "decimal", minimumFractionDigits: 2 };

    const navigate = useNavigate();


    const {
        updating,
        customerId,
        cart,
        customer,
        customerRewardItem,
        rewardsThreshold,
        cartProducts,
        setLinePricingByProductId,
        setTotalPrice: setCartTotalPrice,
        setOriginalPrice: setCartOriginalPrice,
        setUpdating,
        getCart,
        setCartAmount,
        addOrder,
        applyDiscount,
        updateCart,
        getDelivery,
        setCartOpen,
        setOrdering,
        getCustomer,
    } = useBetween(useApi);

    const allDays = [0, 1, 2, 3, 4, 5, 6];
    const filteredDays = allDays.filter((day) => filterDays.includes(day));

    const removeCart = () => {
        let formData = {};
        formData = {
            sessionId: cart.customerId,
            customerId: cart.customerId,
            products: []
        };
        updateCart(cart._id, formData);
    };

    const handleClose = () => {
        setShow(false);
        navigate("/collection/all");
        removeCart();
    };

    const handleViewOrderDetails = () => {
        setShow(false);
        navigate("/profile/orders");
        removeCart();
    };

    useEffect(() => {
        if (!customerId) {
            return;
        }

        let isMounted = true;

        const fetchCustomerAndDelivery = async () => {
            setStatus(true);
            try {
                const customerResponse = await getCustomer(customerId);
                if (!isMounted) {
                    return;
                }

                const customerData = customerResponse.customer;
                getCart(customerId);

                const zoneId = customerData.ShippingZoneID
                    .toLowerCase()
                    .replace("zone ", "")
                    .toUpperCase();
                const deliveryResponse = await getDelivery(zoneId);
                if (!isMounted) {
                    return;
                }

                setFilterDays(deliveryResponse.delivery.available);
                let cutoffHour = deliveryResponse.cutoff.time;
                if (deliveryResponse.cutoff.day === "pm" && deliveryResponse.cutoff.time !== 12) {
                    cutoffHour = deliveryResponse.cutoff.time + 12;
                }

                if (deliveryResponse.cutoff.day === "am" && deliveryResponse.cutoff.time === 12) {
                    cutoffHour = 0;
                }
                const minDate = moment
                    .tz("America/Los_Angeles")
                    .add(deliveryResponse.delivery.leadTime, "days")
                    .add(cutoffHour, "hours")
                    .toDate();
                setStartDate(minDate);

                if (customerData.DeliveryTimeOpen) {
                    setDeliveryTimeOpen(
                        moment(`2023-1-1 ${customerData.DeliveryTimeOpen}`).toDate()
                    );
                }
                if (customerData.DeliveryTimeClosed) {
                    setDeliveryTimeClosed(
                        moment(`2023-1-1 ${customerData.DeliveryTimeClosed}`).toDate()
                    );
                }
            } catch (error) {
                console.error("Failed to load checkout data.", error);
                toast.error("Error occured, please contact you representative");
            } finally {
                if (isMounted) {
                    setStatus(false);
                    setCartOpen(false);
                }
            }
        };

        fetchCustomerAndDelivery();

        return () => {
            isMounted = false;
        };
    }, [customerId]);

    useEffect(() => {
        let price = 0;
        let originalPrice = 0;
        const details = [];

        if (Object.keys(cart).length) {
            cart.products.map((item) => {
                let detail = {
                    InventoryID: {
                        value: cartProducts[item.productId].InventoryID.value
                    },
                    OrderQty: {
                        value: item.quantity
                    },
                    SKUDescription: {
                        value: cartProducts[item.productId].SKUDescription.value
                    },
                    StrainDescription: {
                        value:
                            cartProducts[item.productId].StrainDescription.value
                    },
                    DefaultPrice: {
                        value: cartProducts[item.productId].DefaultPrice.value
                    },
                    Primaryproductimagefirstdisplayed: {
                        value:
                            cartProducts[item.productId]
                                .Primaryproductimagefirstdisplayed.value
                    }
                };

                details.push(detail);

                price +=
                    item.quantity *
                    cartProducts[item.productId].DefaultPrice.value;
                originalPrice +=
                    item.quantity *
                    cartProducts[item.productId].OriginalPrice.value;
            });

            setCartDetails(details);
            setTotalPrice(price);
            setOriginalPrice(originalPrice);
            setCartAmount(cart.products.length);
        }
    }, [cart, cartProducts]);

    const handleSubmit = () => {
        if (rewardsThreshold) {
            if (totalPrice > rewardsThreshold.threshold1) {
                if (!customerRewardItem) {
                    toast.error(
                        "Please select a reward item before submitting your order."
                    );
                    return false;
                } else {
                    if (
                        cartDetails.findIndex(
                            (item) =>
                                item.InventoryID.value ===
                                customerRewardItem.InventoryID.value
                        ) < 0
                    )
                        cartDetails.push({
                            InventoryID: customerRewardItem.InventoryID,
                            Primaryproductimagefirstdisplayed:
                                customerRewardItem.ImageLink,
                            OrderQty: { value: 1 },
                            SKUDescription: {
                                value: ""
                            },
                            StrainDescription: {
                                value: ""
                            },
                            DefaultPrice: {
                                value: ""
                            }
                        });
                }
            }
        }

        if (date) {
            // setUpdating(true);
            const formData = {
                note: {
                    value: note
                },
                CustomerID: {
                    value: customerId
                },
                RequestedOn: {
                    value: date
                },
                // NewDeliveryTime: {
                //     DeliveryTimeOpen: deliveryTimeOpen
                //         ? moment(deliveryTimeOpen).format("hh:mm A")
                //         : "",
                //     DeliveryTimeClosed: deliveryTimeClosed
                //         ? moment(deliveryTimeClosed).format("hh:mm A")
                //         : "",
                //     MakeDeliveryTime: defaultDelivery
                // },
                Details: cartDetails
            };
            if (appliedCoupon?.code) {
                formData.discountCode = appliedCoupon.code;
            }
            setOrdering(true);
            setUpdating(true);
            addOrder(formData)
                .then(() => {
                    //setShow(true);
                    setOrdering(false);
                    setUpdating(false);
                })
                .catch((err) => {
                    console.log("Error occored during order place", err);
                });
            setTimeout(() => {
                setShow(true);
            }, 1000);
        } else {
            toast.error("Please select a delivery date.");
        }
    };

    const buildCouponLinePricing = (applicableProductIds, discountAmount) => {
        if (!Array.isArray(applicableProductIds) || !cart?.products?.length) {
            return { linePricingByProductId: {}, totalDiscount: 0 };
        }
        const applicableProductSet = new Set(applicableProductIds);
        const lineSubtotalsByProductId = {};
        let applicableSubtotal = 0;

        for (const cartLine of cart.products) {
            const productId = cartLine?.productId;
            if (!productId || !applicableProductSet.has(productId)) continue;
            const cartProduct = cartProducts?.[productId];
            const unitPrice = Number(cartProduct?.DefaultPrice?.value ?? 0);
            const quantity = Number(cartLine?.quantity ?? 0);
            const lineSubtotal = unitPrice * quantity;
            applicableSubtotal += lineSubtotal;
            lineSubtotalsByProductId[productId] = {
                quantity,
                unitPrice,
                lineSubtotal
            };
        }

        if (applicableSubtotal <= 0 || discountAmount <= 0) {
            return { linePricingByProductId: {}, totalDiscount: 0 };
        }

        const totalDiscount = Math.min(discountAmount, applicableSubtotal);
        const linePricingByProductId = {};
        for (const [productId, lineInfo] of Object.entries(lineSubtotalsByProductId)) {
            const lineDiscount = (lineInfo.lineSubtotal / applicableSubtotal) * totalDiscount;
            const lineTotal = lineInfo.lineSubtotal - lineDiscount;
            const discountedUnitPrice = lineInfo.quantity > 0
                ? lineTotal / lineInfo.quantity
                : lineInfo.unitPrice;
            linePricingByProductId[productId] = {
                quantity: lineInfo.quantity,
                lineSubtotal: lineInfo.lineSubtotal,
                lineTotal,
                lineDiscount,
                originalUnitPrice: lineInfo.unitPrice,
                discountedUnitPrice,
                promotionType: "DISCOUNT"
            };
        }

        return { linePricingByProductId, totalDiscount };
    };

    const handleApplyDiscount = (event) => {
        event.preventDefault();
        const trimmedDiscountCode = discountCode.trim();
        if (!trimmedDiscountCode) {
            toast.error("Please enter a discount code.");
            return;
        }
        setApplyingCoupon(true);
        applyDiscount(customerId, trimmedDiscountCode)
            .then((response) => {
                if (response?.type === "success") {
                    setAppliedCoupon(response.coupon || null);
                    setDiscountCode(response?.coupon?.code || trimmedDiscountCode);
                    const discountAmount = Number(response?.coupon?.maxDiscountAmount || 0);
                    const { linePricingByProductId, totalDiscount } =
                        buildCouponLinePricing(response?.applicableProductIds, discountAmount);
                    if (Object.keys(linePricingByProductId).length) {
                        setLinePricingByProductId(linePricingByProductId);
                        setCartOriginalPrice(originalPrice);
                        setCartTotalPrice(Math.max(0, originalPrice - totalDiscount));
                    }
                    toast.success(response?.message || "Discount code applied.");
                } else {
                    setAppliedCoupon(null);
                    toast.error(response?.message || "Unable to apply discount code.");
                }
            })
            .catch((error) => {
                setAppliedCoupon(null);
                toast.error(error?.message || "Unable to apply discount code.");
            })
            .finally(() => setApplyingCoupon(false));
    };

    const handleCancelDiscount = () => {
        setAppliedCoupon(null);
        setDiscountCode("");
        getCart(customerId);
        toast.success("Discount removed.");
    };

    return (
        <Layout>
            <div className='checkout-background'>
                <Container className='checkout-container'>
                    <Row>
                        <Col
                            sm={12}
                            lg={8}
                            md={6}
                            style={{ background: "#fff" }}
                        >
                            <Form className='checkout-summary'>
                                {Object.keys(customer).length ? (
                                    <>
                                        <h4 className='mb-3'>
                                            Delivery Information
                                        </h4>
                                        <div className='check-card'>
                                            <Row>
                                                <Col md={6} xs={12}>
                                                    <Form.Group className='form-group'>
                                                        <Form.Label className='mb-2'>
                                                            Address
                                                        </Form.Label>
                                                        <div className='form-group-content'>
                                                            <p>
                                                                {
                                                                    customer.AddressLine1
                                                                }
                                                            </p>
                                                            <p>
                                                                {customer.City},{" "}
                                                                {customer.State}{" "}
                                                                {
                                                                    customer.PostalCode
                                                                }
                                                            </p>
                                                        </div>
                                                    </Form.Group>
                                                </Col>
                                                <Col md={6} xs={12}>
                                                    <Form.Group className='form-group'>
                                                        <Form.Label className='mb-2'>
                                                            License Number
                                                        </Form.Label>
                                                        <div className='form-group-content'>
                                                            <p>
                                                                {
                                                                    customer[
                                                                    "LIC#1: Primary License"
                                                                    ]
                                                                }
                                                            </p>
                                                        </div>
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                        </div>
                                    </>
                                ) : null}
                                <h4 className='mb-4'>Schedule Delivery</h4>
                                <div className='check-card mb-4'>
                                    <Row className='date-time-picker'>
                                        <Col
                                            lg={
                                                customer.DeliveryTimeOpen &&
                                                    customer.DeliveryTimeClosed
                                                    ? "12"
                                                    : "12"
                                            }
                                            className='mb-3'
                                        >
                                            <Form.Label>
                                                Desired Delivery Date
                                            </Form.Label>
                                            <DatePicker
                                                selected={date}
                                                minDate={startDate}
                                                onChange={(date) =>
                                                    setDate(date)
                                                }
                                                filterDate={(date) =>
                                                    filteredDays.includes(
                                                        date.getDay()
                                                    )
                                                }
                                                placeholderText='Select a delivery date'
                                            />
                                            <p>
                                                Available delivery dates are
                                                displayed based on your
                                                location.{" "}
                                            </p>
                                        </Col>
                                        {/* {customer.DeliveryTimeOpen &&
                                            customer.DeliveryTimeClosed && (
                                                <Col lg={6} className='mb-3'>
                                                    <div className='d-flex'>
                                                        <div>
                                                            <Form.Label>
                                                                Intake hours
                                                                begin
                                                            </Form.Label>
                                                            <DatePicker
                                                                selected={
                                                                    deliveryTimeOpen
                                                                }
                                                                onChange={(
                                                                    date
                                                                ) => {
                                                                    setDeliveryTimeOpen(
                                                                        date
                                                                    );
                                                                    setDefaultDelivery(
                                                                        false
                                                                    );
                                                                }}
                                                                showTimeSelectOnly
                                                                showPopperArrow={
                                                                    false
                                                                }
                                                                timeIntervals={
                                                                    15
                                                                }
                                                                timeCaption='Time'
                                                                dateFormat='h:mm aa'
                                                                placeholderText='--:-- AM/PM'
                                                                isClearable
                                                            />
                                                        </div>
                                                        <div>
                                                            <Form.Label>
                                                                Intake hours
                                                                close
                                                            </Form.Label>
                                                            <DatePicker
                                                                selected={
                                                                    deliveryTimeClosed
                                                                }
                                                                onChange={(
                                                                    date
                                                                ) => {
                                                                    setDeliveryTimeClosed(
                                                                        date
                                                                    );
                                                                    setDefaultDelivery(
                                                                        false
                                                                    );
                                                                }}
                                                                showTimeSelectOnly
                                                                showPopperArrow={
                                                                    false
                                                                }
                                                                timeIntervals={
                                                                    15
                                                                }
                                                                timeCaption='Time'
                                                                dateFormat='h:mm aa'
                                                                placeholderText='--:-- AM/PM'
                                                                isClearable
                                                            />
                                                        </div>
                                                    </div>
                                                    {(moment(
                                                        deliveryTimeClosed
                                                    ).format("h:mm A") !==
                                                        customer.DeliveryTimeClosed ||
                                                        moment(
                                                            deliveryTimeOpen
                                                        ).format("h:mm A") !==
                                                            customer.DeliveryTimeOpen) && (
                                                        <Form.Group
                                                            className='mb-3 delivery-time'
                                                            controlId='defaultDeliveryDateCheckbox'
                                                        >
                                                            <Form.Check
                                                                onChange={(e) =>
                                                                    setDefaultDelivery(
                                                                        e.target
                                                                            .checked
                                                                    )
                                                                }
                                                                checked={
                                                                    defaultDelivery
                                                                }
                                                                type='checkbox'
                                                                label='Save as new default intake
                                                    hours.'
                                                                disabled={
                                                                    !deliveryTimeClosed ||
                                                                    !deliveryTimeOpen
                                                                }
                                                            />
                                                        </Form.Group>
                                                    )}
                                                </Col>
                                            )} */}
                                    </Row>
                                    <Row>
                                        <Col md={12}>
                                            <Form.Group className='form-group-delivery-note'>
                                                <Form.Label>
                                                    Delivery Notes
                                                </Form.Label>
                                                <Form.Control
                                                    as='textarea'
                                                    value={note}
                                                    rows={2}
                                                    maxLength='255'
                                                    onChange={(event) =>
                                                        setNote(
                                                            event.target.value
                                                        )
                                                    }
                                                    placeholder='Leave your notes here'
                                                    required
                                                    className='mb-0'
                                                />
                                                <Form.Label className='maximum-character float-right'>
                                                    {255 - note.length}{" "}
                                                    characters left
                                                </Form.Label>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </div>
                                <div className='check-card mb-4'>
                                    <Row>
                                        <Col md={12}>
                                            <Form.Group className='form-group-delivery-note' controlId='discountCode'>
                                                <Form.Label>
                                                    Discount Code
                                                </Form.Label>
                                                <div className='d-flex gap-2'>
                                                    <Form.Control
                                                        value={discountCode}
                                                        onChange={(event) => setDiscountCode(event.target.value)}
                                                        placeholder='Enter discount code'
                                                        maxLength='32'
                                                    />
                                                    <AwareButton
                                                        className='btn btn-secondary second'
                                                        type='button'
                                                        onClick={handleApplyDiscount}
                                                        disabled={applyingCoupon || Boolean(appliedCoupon?.code)}
                                                    >
                                                        {applyingCoupon ? "Applying" : "Apply"}
                                                    </AwareButton>
                                                    {appliedCoupon?.code ? (
                                                        <AwareButton
                                                            className='btn btn-outline-secondary'
                                                            type='button'
                                                            onClick={handleCancelDiscount}
                                                        >
                                                            Cancel
                                                        </AwareButton>
                                                    ) : null}
                                                </div>
                                                {appliedCoupon?.code ? (
                                                    <Form.Text className='mt-2 d-block'>
                                                        {`Applied: ${appliedCoupon.code}`}
                                                        {appliedCoupon.remainingUsesCount !== undefined
                                                            ? ` (Remaining uses: ${appliedCoupon.remainingUsesCount})`
                                                            : ""}
                                                    </Form.Text>
                                                ) : null}
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </div>
                                <h4 className='mb-3'>
                                    Please contact your rep with any additional
                                    notes
                                </h4>
                                <div className='check-card'>
                                    {Object.keys(customer).length ? (
                                        <div className='submit-group'>
                                            <AwareButton
                                                className='btn me-3 btn-secondary second'
                                                href={`tel:${customer[
                                                    "IA:Representative Phone"
                                                ]
                                                    }`}
                                            >
                                                <PhoneIcon />
                                                Call Rep
                                            </AwareButton>
                                            <AwareButton
                                                className='btn btn-secondary second'
                                                href={`mailto:${customer[
                                                    "IA:Representative Email"
                                                ]
                                                    }`}
                                            >
                                                <EmailIcon />
                                                Email Rep
                                            </AwareButton>
                                        </div>
                                    ) : null}
                                </div>
                            </Form>
                        </Col>
                        <Col sm={12} lg={4} md={6} className='ps-xl-0'>
                            {/* <div
                                className={`order-summary d-flex justify-content-between flex-column ${
                                    multipleCustomers
                                        ? "hasMultipleCustomers"
                                        : ""
                                }`}
                            >
                                <div className='order-items d-flex flex-column'>
                                    <div className='d-block'>
                                        <h4>Order Summary</h4>
                                    </div>
                                    {Object.keys(cart).length &&
                                        cart.products.length > 0 && (
                                            <CartTimer showTimeOnly={false} />
                                        )}
                                    {Object.keys(cart).length
                                        ? cart.products.map((item) => (
                                              <CheckoutItem
                                                  key={item.productId}
                                                  item={item}
                                              />
                                          ))
                                        : null}
                                </div>
                                <div className='place-container'>
                                    {rewardsThreshold && (
                                        <div className='gift-item-wrapper'>
                                            <div className='d-flex align-items-center'>
                                                <Image src={GiftBoxIcon} />
                                                {totalPrice <
                                                rewardsThreshold.threshold1 ? (
                                                    <div>{`Add $${rewardsThreshold.threshold1 -
                                                        totalPrice} to unlock a reward.`}</div>
                                                ) : customerRewardItem ? (
                                                    <div>
                                                        {`Free ${customerRewardItem.ItemName.value}. `}
                                                        <span
                                                            className='text-link'
                                                            onClick={() =>
                                                                setShowGamificationPopOver(
                                                                    true
                                                                )
                                                            }
                                                        >
                                                            Change
                                                        </span>
                                                    </div>
                                                ) : (
                                                    <div
                                                        className='text-link'
                                                        onClick={() =>
                                                            setShowGamificationPopOver(
                                                                true
                                                            )
                                                        }
                                                    >{`Select free gift`}</div>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                    <div className='order-summary-total d-flex'>
                                        <label>Total</label>
                                        <p>
                                            {originalPrice !== totalPrice ? (
                                                <span className='origin'>
                                                    $
                                                    {toTwoDecimals(
                                                        originalPrice
                                                    )}
                                                </span>
                                            ) : null}
                                            $
                                            {totalPrice.toLocaleString(
                                                "en-US",
                                                options
                                            )}
                                        </p>
                                    </div>
                                    <AwareButton
                                        className='place-order-cta primary'
                                        onClick={() => {
                                            handleSubmit();
                                        }}
                                    >
                                        Place Order
                                    </AwareButton>
                                </div>
                            </div> */}
                            <Cart
                                status={true}
                                setStatus={() => console.log("clicked")}
                                currentPage='checkout'
                                handlePlaceOrders={() => handleSubmit()}
                            />
                        </Col>
                    </Row>
                </Container>
            </div>
            <Modal
                className='quick-view-modal order-confirm'
                centered
                show={show}
                size='md'
                onHide={handleClose}
            >
                <Modal.Header closeButton />
                <Modal.Body>
                    <Row>
                        <Col sm={12}>
                            <div className='product-details product-order-success'>
                                <div className='d-flex justify-content-center mb-4'>
                                    <Image
                                        src={OrderSuccessIcon}
                                        width='180px'
                                        height='auto'
                                        alt='icon'
                                    />
                                </div>
                                <h5 className='text-center mb-2 h6'>
                                    Order Submitted
                                </h5>
                                <p className='text-center mb-4'>
                                    You will receive a copy of your invoice via
                                    email within 24 hours.
                                </p>
                                <div className='description mb-3'>
                                    <label className='mb-2'>Total</label>
                                    <p>
                                        $
                                        {totalPrice.toLocaleString(
                                            "en-US",
                                            options
                                        )}
                                    </p>
                                </div>
                                <div className='description mb-3'>
                                    <label className='mb-2'>
                                        Desired Delivery Date
                                    </label>
                                    <p>{date ? toDateType(date) : null}</p>
                                </div>
                                <div className='description mb-4'>
                                    <label className='mb-2'>
                                        Delivery Note
                                    </label>
                                    <p>{note}</p>
                                </div>
                                <div className='d-flex justify-content-center mb-4'>
                                    <AwareButton
                                        onClick={() => handleClose()}
                                        className='mt-4 primary btn-primary me-3'
                                    >
                                        Continue Shopping
                                    </AwareButton>

                                    <AwareButton
                                        onClick={() => handleViewOrderDetails()}
                                        className='mt-4 primary btn-primary'
                                    >
                                        View Order Details
                                    </AwareButton>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
            {status ? (
                <div className='page-loading'>
                    <Spinner animation='border' role='status'>
                        <span className='visually-hidden'>Loading...</span>
                    </Spinner>
                </div>
            ) : null}

            {updating ? (
                <div className='update-loading'>
                    <Spinner animation='border' role='status'>
                        <span className='visually-hidden'>Loading...</span>
                    </Spinner>
                </div>
            ) : null}

            {/* {updating ? (
                <div className='update-loading'>
                    <Spinner animation='border' role='status'>
                        <span className='visually-hidden'>Loading...</span>
                    </Spinner>
                </div>
            ) : null} */}
        </Layout>
    );
};

export default Checkout;
